import { Link, useNavigate } from 'react-router-dom'

/**
 * PageHeader — sits directly below the navbar on all bookkeeper pages.
 *
 * Props:
 *   back        { label, to }   — back button destination
 *   title       string          — main page title (large)
 *   subtitle    string          — optional secondary line below title
 *   actions     ReactNode       — buttons to render on the right
 */
export default function PageHeader({ back, title, subtitle, actions }) {
  const navigate = useNavigate()

  return (
    <div style={{
      background: 'var(--white)',
      borderBottom: '1.5px solid var(--surface-2)',
      marginBottom: 32,
    }}>
      <div className="container" style={{ padding: '0 24px' }}>

        {/* Back navigation strip */}
        {back && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            height: 36,
            borderBottom: '1px solid var(--surface-2)',
          }}>
            <button
              onClick={() => navigate(back.to)}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 6,
                background: 'none', border: 'none', cursor: 'pointer',
                color: 'var(--ink-muted)', fontSize: '0.82rem',
                padding: '0', fontFamily: 'var(--font-body)',
                transition: 'color 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--ink)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--ink-muted)'}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
                <path d="M9 2L4 7L9 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {back.label}
            </button>
          </div>
        )}

        {/* Title + actions row */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          padding: '18px 0',
          flexWrap: 'wrap',
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)', lineHeight: 1.2 }}>
              {title}
            </h2>
            {subtitle && (
              <p style={{ margin: '4px 0 0', fontSize: '0.83rem', color: 'var(--ink-muted)' }}>
                {subtitle}
              </p>
            )}
          </div>
          {actions && (
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
              {actions}
            </div>
          )}
        </div>

      </div>
    </div>
  )
}
